module.exports = __webpack_public_path__ + "static/media/imgop_UoMLogo.87d64e44.jp2";